import _ from 'underscore';
import Backbone from 'backbone';
import Localizer from 'localizer';
import Personalizer from 'personalizer';
import templateHtml from 'pages/resource_not_found/templates/resourceNotFound.html';
import templateHtml2 from 'pages/resource_not_found/templates/resourceNotFound2.html';
import PageView from 'views/main/PageView';

export default PageView.extend({
    propertyFiles: ['/common/common', '/resource_not_found/resource_not_found', '/privileges/privileges'],

    events: {},

    initializePage: function(args) {
        this.pageType = args.pageType;
    },

    render: function() {
        if (this.pageType === 'activity') {
            const titleTypeName = Localizer.localize('activity');
            const descriptionTypeName = Localizer.localize('privileges.activity');
            const title = Localizer.localize('access.title.unavailable', titleTypeName);
            const description = Localizer.localize('access.desc.unavailable', descriptionTypeName);
            this.$el.html(
                _.template(templateHtml2)({
                    title,
                    description
                })
            );
            this.$el.addClass('centered');
        } else {
            this.$el.html(
                _.template(templateHtml)({
                    Localizer: Localizer
                })
            );
        }
    },

    onDependenciesLoaded: function(tripCount) {},

    reload: function() {
        Window.App.displayPage(this);
    }
});
